export const getThemePreference = () => {
  try {
    return localStorage.getItem('ps-theme') === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
};